<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :loading="loading"
      >
        <template slot="status" slot-scope="text">
          <span v-if="text === 1" class="badge badge-success">Active</span>
          <span v-else class="badge badge-danger">Inactive</span>
        </template>

        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
               @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              Edit
            </a>

            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
               @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <edit-program @onEdited="handleAfterEdit" />
  </div>
</template>

<script>
import EditProgram from '@/components/tuition/manage/program/Edit'

const columns = [
  { title: 'Program Name', dataIndex: 'name', key: 'name', className: 'text-wrap' },
  { title: 'Code', dataIndex: 'code', key: 'code', className: 'text-center' },
  { title: 'Description', dataIndex: 'description', key: 'description', className: 'text-wrap' },
  { title: 'Total Sessions', dataIndex: 'sessions_count', key: 'sessions_count', className: 'text-center' },
  { title: 'Total Enrollments', dataIndex: 'enrollments_count', key: 'enrollments_count', className: 'text-center' },
  { title: 'Status', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, className: 'text-center' },
  { title: 'Actions', key: 'action', scopedSlots: { customRender: 'action' }, className: 'text-right', width: 200 },
]

export default {
  name: 'TuitionProgramTable',
  components: {
    EditProgram,
  },
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns,
    }
  },
  methods: {
    showEditModal(record) {
      this.$eventBus.$emit('openEditTuitionProgram', record)
    },
    handleAfterEdit() {
      this.$emit('updateTable')
    },
    onDelete(record) {
      this.$confirm({
        title: 'Are you sure you want to delete this program?',
        content: `You are about to delete "${record.name}". This will remove any sessions and enrollments associated with it.`,
        okText: 'Yes, Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/tuition/programs/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification.success({
                message: 'Deleted Successfully!',
                description: `Program "${record.name}" has been deleted.`,
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
      })
    },
  },
}
</script>
